import { useMemo } from "react";

import numeral from "numeral";
import { useBalanceStore } from "../../../_store/balanceStore";
import {
  DonutChartEmpty,
  DonutChartMain,
} from "../../../components/chart/DonutChartMain";
import { SumSaving } from "../../../functions/Balance/sumSaving";
import { SumVariableExpense } from "../../../functions/Balance/sumVariableExpense";
import { ICON_NAVIGATE_BALANCE } from "../../../utils/useIcons";
import {
  STYLE_BORDER_YELLOW_PROPOTION,
  STYLE_CARD_PROPOTION,
  STYLE_HEADER_SECTION_PROPOTION,
  STYLE_TITLE_PROPOTION,
} from "../../../utils/useStyle";
import { BoxWhite } from "../styles/Card";

const ViewOutComeProportion = ({
  onClick,
  formBL,
  addExpensesInvest,
  addExpensesVariable,
  displaySaving = 0,
}) => {
  const setBalanceData = useBalanceStore((state) => state.setBalanceData);
  const balanceData = useBalanceStore((state) => state.balanceData);

  const netCashFlow = useMemo(() => {
    const result =
      Number(balanceData?.sum_salary_peryear || 0) +
      Number(balanceData?.sum_interest_peryear || 0) +
      Number(balanceData?.sum_other_income || 0) -
      (Number(balanceData?.sum_expenses_fixed || 0) +
        SumSaving(addExpensesInvest) +
        SumVariableExpense(addExpensesVariable));
    return isNaN(result) ? 0 : result;
  }, [formBL, balanceData]);

  // console.log("netCashFlow", netCashFlow)
  // console.log("SumSaving(addExpensesInvest)",SumSaving(addExpensesInvest))

  return (
    <div className={STYLE_CARD_PROPOTION}>
      <div className={STYLE_HEADER_SECTION_PROPOTION}>
        <div>
          <div className={STYLE_TITLE_PROPOTION}>สัดส่วนรายจ่าย</div>
          <div className={STYLE_BORDER_YELLOW_PROPOTION}></div>
        </div>
        <ICON_NAVIGATE_BALANCE onClick={onClick} />
      </div>

      {Number(balanceData?.sum_expenses_fixed || 0) +
        Number(balanceData?.sum_expenses_variable || 0) +
        (netCashFlow + SumSaving(addExpensesInvest) < 0
          ? 0
          : netCashFlow + SumSaving(addExpensesInvest)) <=
        // Number(balanceData?.sum_expenses_invest_saving || 0)
        0 ||
      isNaN(
        Number(balanceData?.sum_expenses_fixed || 0) +
          Number(balanceData?.sum_expenses_variable || 0) +
          (netCashFlow + SumSaving(addExpensesInvest) < 0
            ? 0
            : netCashFlow + SumSaving(addExpensesInvest))
        // Number(balanceData?.sum_expenses_invest_saving || 0)
      ) ? (
        <DonutChartEmpty text={`ค่าใช้จ่าย`} />
      ) : (
        <DonutChartMain
          text={`ค่าใช้จ่าย`}
          value={numeral(
            Number(balanceData?.sum_expenses_fixed || 0) +
              Number(balanceData?.sum_expenses_variable || 0) +
              (netCashFlow + SumSaving(addExpensesInvest) < 0
                ? 0
                : netCashFlow + SumSaving(addExpensesInvest))
          ).format("0,0")}
          // defalut={getOutcomeBalance > 0 ? 0 : 100}
          data1={Number(balanceData?.sum_expenses_fixed || 0)}
          data2={Number(balanceData?.sum_expenses_variable || 0)}
          data3={
            netCashFlow + SumSaving(addExpensesInvest) < 0
              ? 0
              : netCashFlow + SumSaving(addExpensesInvest)
          }
          // data3={Number(balanceData?.sum_expenses_invest_saving || 0)}
        />
      )}

      <BoxWhite
        info
        title="ค่าใช้จ่ายคงที่"
        icon="/images/finance_outcome2.png"
        colortext="text-yellow400"
        value={Number(balanceData?.sum_expenses_fixed || 0)}
      />

      <BoxWhite
        info
        title="ค่าใช้จ่ายผันแปร"
        icon="/images/finance_variable2.png"
        colortext="text-red400"
        value={Number(balanceData?.sum_expenses_variable || 0)}
      />

      <BoxWhite
        info
        title="ค่าใช้จ่ายเพื่อการออม/ลงทุน"
        icon="/images/finance_invest2.png"
        colortext="text-maingreen"
        // value={displaySaving}
        value={
          netCashFlow + SumSaving(addExpensesInvest) < 0
            ? 0
            : netCashFlow + SumSaving(addExpensesInvest)
        }
      />
    </div>
  );
};

export default ViewOutComeProportion;
